export default __webpack_public_path__ + "static/media/chairs-1.c822a740.png";